import React from "react";
import { Modal } from "react-bootstrap";

const DeletePost = (props) => {
  return (
    <Modal
      {...props}
      className="delete-popup"
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>
          {props?.title
            ? props?.title
            : "Are you sure you want to delete this post?"}
        </h4>
        <div className="button-row">
          <button className="cancel-btn" onClick={props.onHide}>
            {props?.cancelButtonText ? props?.cancelButtonText : "Cancel"}
          </button>
          <div
            onClick={() => props.deletePostHandler(props.id)}
            className="button"
            style={{ cursor: "pointer" }}
          >
            Yes
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeletePost;
